export const layout = {
  methods: {
    // TODO: Get inline/non-inline styling from field groupings, similar to `section`
    formBlockStyles(fieldData) {
      const inlineFieldTypes = [
        'text_inline',
        'radio_inline',
        'select_inline',
        'checkbox_inline',
        'text_inline_first',
        'radio_inline_first',
        'select_inline_first',
        'checkbox_inline_first',
      ];

      const inlineClass = (inlineFieldTypes.indexOf(fieldData.field_type) !== -1 ? 'd-inline-block' : '');

      return `form-group mx-3 ${inlineClass}`;
    },
  },
};

export const none = {
  // TODO: Remove this hack that suppresses the eslint error: Prefer default export "export const uiHelpers = {""
};



// WEBPACK FOOTER //
// ./src/mixins/layout.js